import * as React from 'react';
import { useState, useEffect } from 'react';
import { HeaderSearchResults } from './HeaderSearchResults/HeaderSearchResults';

interface SearchResultsBlockProps {
  settings?: {
    tile_type?: string;
    products_per_page?: number;
    default_sort?: string;
    default_sort_direction?: string;
    [key: string]: any;
  };
  className?: string;
}

export const SearchResultsBlock: React.FC<SearchResultsBlockProps> = ({ settings, className = '' }) => {
  const blockSettings = settings?.block_settings || settings || {};
  const [searchResults, setSearchResults] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [seeAllProductsUrl, setSeeAllProductsUrl] = useState<string>('');

  // Listen for search results from the search provider
  useEffect(() => {
    const handleSearchResults = (event: Event) => {
      const { products, query, totalResults } = (event as CustomEvent).detail || {};
      
      if (products && Array.isArray(products)) {
        setSearchResults(products);
        setTotalResults(totalResults || products.length);
        setSearchQuery(query || '');
        setSeeAllProductsUrl(`/search?q=${encodeURIComponent(query || '')}`);
      }
    };

    // Add event listener for search results
    window.addEventListener('searchrequest-products-complete', handleSearchResults);

    // Cleanup
    return () => {
      window.removeEventListener('searchrequest-products-complete', handleSearchResults);
    };
  }, []);

  const handleSeeAllProducts = () => {
    // Navigate to full search results page
    window.location.href = seeAllProductsUrl || `/search?q=${encodeURIComponent(searchQuery)}`;
  };

  // Only render if we have search results
  if (!searchResults.length || !searchQuery) {
    return null;
  }

  return (
    <div className={`w-full ${className}`}>
      <HeaderSearchResults
        products={searchResults}
        totalResults={totalResults}
        query={searchQuery}
        settings={{
          ...settings,
          block_settings: {
            ...blockSettings,
            tile_type: blockSettings.tile_type || 'default'
          }
        }}
        onSeeAllProducts={handleSeeAllProducts}
      />
    </div>
  );
};
